// extracted by mini-css-extract-plugin
export var circle = "_bf-1";
export var exitConfirmationModal = "_bf-5";
export var iframe = "_bf-0";
export var offline = "_bf-3";
export var online = "_bf-2";
export var workstationSelectError = "_bf-4";